import React from 'react';
import { CheckIcon, ZapIcon, DownloadIcon, ShieldCheckIcon, SmartphoneIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function OfferSection() {
  return <section id="oferta" className="w-full py-20 px-6 pt-[30px] pb-[30px]" style={{
    background: 'var(--brown)'
  }} aria-label="La oferta" data-id="element-275">
      <div className="max-w-4xl mx-auto" data-id="element-276">
        {/* Header */}
        <div className="text-center mb-14" data-id="element-277">
          <p className="text-sm font-bold tracking-widest uppercase mb-4" style={{
          color: 'var(--gold)'
        }} data-id="element-278">
            📦 Lo Que Obtienes Hoy
          </p>
          <h2 className="text-4xl md:text-5xl font-bold mb-4" style={{
          color: 'var(--cream)',
          fontFamily: 'Playfair Display, serif'
        }} data-id="element-279">
            Todo Incluido en el Ebook
          </h2>
        </div>

        {/* Value table */}
        <div className="rounded-2xl overflow-hidden mb-10 shadow-2xl" data-id="element-280">
          <table className="w-full" aria-label="Valor incluido en el ebook" data-id="element-281">
            <thead data-id="element-282">
              <tr style={{
              background: '#5C3D2E'
            }} data-id="element-283">
                <th className="px-6 py-4 text-left text-sm font-bold tracking-wider uppercase" style={{
                color: 'var(--gold-light)'
              }} data-id="element-284">
                  Incluido en el Ebook
                </th>
                <th className="px-6 py-4 text-right text-sm font-bold tracking-wider uppercase" style={{
                color: 'var(--gold-light)'
              }} data-id="element-285">
                  Valor
                </th>
              </tr>
            </thead>
            <tbody data-id="element-286">
              <tr style={{
              background: 'var(--cream)'
            }} data-id="element-287">
                <td className="px-6 py-4" style={{
                color: 'var(--brown-light)'
              }} data-id="element-288">
                  90+ páginas de contenido profesional
                </td>
                <td className="px-6 py-4 text-right font-bold" style={{
                color: 'var(--brown)'
              }} data-id="element-289">
                  $37 USD
                </td>
              </tr>
              <tr style={{
              background: 'var(--cream-dark)'
            }} data-id="element-290">
                <td className="px-6 py-4" style={{
                color: 'var(--brown-light)'
              }} data-id="element-291">
                  52 recetas completas con ingredientes y pasos
                </td>
                <td className="px-6 py-4 text-right font-bold" style={{
                color: 'var(--brown)'
              }} data-id="element-292">
                  $27 USD
                </td>
              </tr>
              <tr style={{
              background: 'var(--cream)'
            }} data-id="element-293">
                <td className="px-6 py-4" style={{
                color: 'var(--brown-light)'
              }} data-id="element-294">
                  Sistema de 3 Mezclas Maestras
                </td>
                <td className="px-6 py-4 text-right font-bold" style={{
                color: 'var(--brown)'
              }} data-id="element-295">
                  $17 USD
                </td>
              </tr>
              <tr style={{
              background: 'var(--cream-dark)'
            }} data-id="element-296">
                <td className="px-6 py-4" style={{
                color: 'var(--brown-light)'
              }} data-id="element-297">
                  Tabla Maestra de Solución de Problemas
                </td>
                <td className="px-6 py-4 text-right font-bold" style={{
                color: 'var(--brown)'
              }} data-id="element-298">
                  $12 USD
                </td>
              </tr>

              <tr style={{
              background: 'var(--cream)'
            }} data-id="element-299">
                <td className="px-6 py-4" style={{
                color: 'var(--brown-light)'
              }} data-id="element-300">
                  Plan de 30 días de aprendizaje
                </td>
                <td className="px-6 py-4 text-right font-bold" style={{
                color: 'var(--brown)'
              }} data-id="element-301">
                  $9 USD
                </td>
              </tr>
              {/* Total row */}
              <tr style={{
              background: '#5C3D2E'
            }} data-id="element-302">
                <td className="px-6 py-5 font-bold text-lg" style={{
                color: 'var(--gold-light)'
              }} data-id="element-303">
                  VALOR TOTAL
                </td>
                <td className="px-6 py-5 text-right font-bold text-lg line-through" style={{
                color: 'var(--gold-light)',
                opacity: 0.7
              }} data-id="element-304">
                  $102 USD
                </td>
              </tr>
              {/* Price row */}
              <tr id="precio" style={{
              background: 'var(--gold)'
            }} data-id="element-305">
                <td colSpan={2} className="px-6 py-5 font-bold text-[20px] text-center" style={{
                color: 'var(--brown)'
              }} data-id="element-306">
                  TU PRECIO HOY — $6,39 USD
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* Launch price callout */}
        <div className="rounded-2xl p-8 text-center mb-10" style={{
        background: 'rgba(255,255,255,0.08)',
        border: '1px solid rgba(201,168,76,0.4)'
      }} data-id="element-307">
          <p className="text-sm font-bold tracking-widest uppercase mb-3" style={{
          color: 'var(--gold)'
        }} data-id="element-308">
            ⚡ Precio Especial de Lanzamiento
          </p>
          <div className="flex flex-col items-center justify-center gap-2 mb-4" data-id="element-309">
            <span className="text-3xl line-through opacity-50" style={{
            color: 'var(--cream)'
          }} data-id="element-310">
              $31,95 USD
            </span>
            <span className="text-5xl font-bold" style={{
            color: 'var(--gold)',
            fontFamily: 'Playfair Display, serif'
          }} data-id="element-311">
              $6,39 USD
            </span>
          </div>
          <p className="text-[14px]" style={{
          color: 'var(--cream)',
          opacity: 0.7
        }} data-id="element-312">
            Este valor se convertirá automáticamente a la moneda de su país.
          </p>
        </div>

        {/* CTA */}
        <div className="flex justify-center mb-10" data-id="element-313">
          <CTAButton text="SÍ, QUIERO MI DULCE LIBERTAD" subtext="Acceso inmediato después del pago • Formato PDF • Garantía de 30 días sin preguntas • Pago 100% seguro" data-id="element-314" />
        </div>

        {/* Trust badges */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-id="element-315">
          <div className="flex flex-col items-center gap-2 text-center" data-id="element-316">
            <ZapIcon className="w-8 h-8" style={{
            color: 'var(--gold)'
          }} aria-hidden="true" data-id="element-317" />
            <p className="text-sm" style={{
            color: 'var(--cream)',
            opacity: 0.8
          }} data-id="element-318">
              Acceso inmediato
            </p>
          </div>
          <div className="flex flex-col items-center gap-2 text-center" data-id="element-319">
            <DownloadIcon className="w-8 h-8" style={{
            color: 'var(--gold)'
          }} aria-hidden="true" data-id="element-320" />
            <p className="text-sm" style={{
            color: 'var(--cream)',
            opacity: 0.8
          }} data-id="element-321">
              PDF descargable
            </p>
          </div>
          <div className="flex flex-col items-center gap-2 text-center" data-id="element-322">
            <ShieldCheckIcon className="w-8 h-8" style={{
            color: 'var(--gold)'
          }} aria-hidden="true" data-id="element-323" />
            <p className="text-sm" style={{
            color: 'var(--cream)',
            opacity: 0.8
          }} data-id="element-324">
              Garantía 30 días
            </p>
          </div>
          <div className="flex flex-col items-center gap-2 text-center" data-id="element-325">
            <SmartphoneIcon className="w-8 h-8" style={{
            color: 'var(--gold)'
          }} aria-hidden="true" data-id="element-326" />
            <p className="text-sm" style={{
            color: 'var(--cream)',
            opacity: 0.8
          }} data-id="element-327">
              Cualquier dispositivo
            </p>
          </div>
        </div>
      </div>
    </section>;
}